<template>
  <div class="form-group" :class="{ 'has-error': hasError }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <select
      class="form-control"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keyup.delete="$emit('input', null)"
      v-on="listeners"
      v-bind="$attrs"
    >
      <option :value="null" disabled selected>
        {{ placeholder || 'Selecione uma opção' }}
      </option>
      <option v-for="(option, index) in options" :key="index" :value="option.value" :selected="option.value === value">
        {{ option.label }}
      </option>
    </select>
    <span class="help-block" v-if="hasError">{{ errors[0] }}</span>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String, Boolean],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    listeners() {
      const listeners = { ...this.$listeners };

      delete listeners.input;

      return listeners;
    },
    hasError() {
      return this.errors && this.errors.length;
    },
  },
};
</script>
